// extracted by mini-css-extract-plugin
module.exports = {"container":"_3vsnXcLCqua9MBFguaIy9S"};